/**
 * File: Fontawesome.js
 *
 * @author Daniel Sturm <d.sturm@zirkeldesign.de>
 */

import {
  library,
  dom,
  icon,
  config,
} from '@fortawesome/fontawesome-svg-core';

import {
  faCircle,
  faCookie,
  faEnvelope,
  faFileDownload,
  faGlobe,
  faMobile,
  // faPhone,
  faMarker,
  faSearch,
  faExclamationCircle,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAt,
  faHeadset,
  faStar,
  faShippingTimed,
  faObjectGroup,
  faBookHeart,
  faHeart,
  faBook,
  faCogs,
  faChevronCircleRight,
  faChevronCircleDown,
  faCheckCircle,
  faFilter,
  faTimes,
  faCalendarAlt,
} from '@fortawesome/pro-light-svg-icons';

// import {
//   faChevronCircleDown,
// } from '@fortawesome/pro-regular-svg-icons';

import {
  faTicketAlt,
  faPhone,
  faChevronUp,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faFacebookF,
  faInstagram,
  faPinterest,
  faYoutube,
  faXing,
} from '@fortawesome/free-brands-svg-icons';

export default class Fontawesome {
  constructor() {
    // Init Fontawesome
    library.add(
      faCircle,
      faCookie,
      faEnvelope,
      faFileDownload,
      faGlobe,
      faMobile,
      faPhone,
      faMarker,
      faSearch,
      faExclamationCircle,
      faAngleDown,
      faAngleLeft,
      faAngleRight,
      faAt,
      faHeadset,
      faStar,
      faShippingTimed,
      faObjectGroup,
      faBookHeart,
      faHeart,
      faBook,
      faCogs,
      faChevronCircleRight,
      faChevronCircleDown,
      faChevronUp,
      faCheckCircle,
      faFilter,
      faTimes,
      faCalendarAlt,
      faTicketAlt,
      faFacebookF,
      faInstagram,
      faPinterest,
      faYoutube,
      faXing,
      faChevronCircleDown
    );

    this._fixLists();

    // config.searchPseudoElements = true;

    // Watch <i></i>
    dom.watch();
  }

  // Prepare lists with icons
  _fixLists() {
    // Rename classes
    document
      .querySelectorAll('ul.downloads')
      .forEach(list => {
        list.classList.add('list-downloads', 'list-styled');
        list.classList.remove('downloads');
      });

    const lists = document.querySelectorAll('.list-styled');

    lists.forEach(list => {
      list.classList.add('fa-ul');

      list.querySelectorAll('li').forEach(node => {
        if (!node.querySelectorAll('.fa-li').length) {
          node.insertAdjacentHTML('afterbegin', '<span class="fa-li"></span>');
        }
      });

      const icons = list.querySelectorAll('.fa-li');

      switch (true) {
        case list.classList.contains('list-downloads'):
          icons.forEach(iconWrapper => {
            iconWrapper.insertAdjacentHTML('afterbegin', icon(faFileDownload).html)
          });
          break;
        case list.classList.contains('list-checks'):
          icons.forEach(iconWrapper => {
            iconWrapper.insertAdjacentHTML('afterbegin', icon(faCheckCircle, {
              classes: ['fa-lg'],
            }).html)
          });
          break;
        case list.classList.contains('list-arrow'):
          icons.forEach(iconWrapper => {
            iconWrapper.insertAdjacentHTML('afterbegin', icon(faChevronCircleRight, {
              classes: ['fa-lg'],
            }).html)
          });
          break;
        default:
          icons.forEach(iconWrapper => {
            iconWrapper.insertAdjacentHTML('afterbegin', icon(faChevronCircleRight, {
              // Changed from fa-xs
              classes: ['fa-md'],
            }).html);
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/Fontawesome.js